<template>
  <div class="footer-bottom">
    <div class="footer-bottom__text">

      <p class="footer-bottom__copyright" v-html="copyright"></p>
      <div class="footer-bottom__links">
        <a v-for="(link, index) in links" :key="index" class="footer-bottom__link" :href="link.link">{{ link.title }}</a>
      </div>
    </div>
    <div class="footer-bottom__logos">
      <a class="hover-default" href="https://my.games/" target="_blank">
        <img :src="getImagePath('my-games-logo.svg')" alt="mygames" />
      </a>
    </div>
  </div>
</template>

<script>
import compatibleRequire from "@app_components/helpers/compatibleRequire";

export default {
  name: "FooterBottom",
  props: {
    copyright: {
      type: String,
      required: true,
    },
    links: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getImagePath(name) {
      return compatibleRequire(require(`../../images/${name}`));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/blocks/footer-bottom.scss";
</style>
